<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div>
        <span style="margin-right: 10px;">
          最新通知时间：{{ noticeTime||"- -" }}</span>
        <span style="margin-right: 10px;">
          最新查询时间：{{ selectTime||"- -" }}</span>
        <el-button size="small" type="primary" @click="putBlacklist">手动查询</el-button>
        <el-button size="small" type="success" @click="clickExcel">导出excel</el-button>
      </div>
    </div>
    <div style="    margin-bottom: 10px;
    color: rgb(255, 104, 123);font-size: 14px;">
     充值记录分为两种方式通知：到账时主动通知和主动查询；系统将每5分钟查询一次当日记录，凌晨12点时查询昨日记录
     </div>
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="交易流水号" slot="bizType" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.outUniqNo || "- -"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款银行" slot="relationNo" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payeeBankOpening || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="收款账号" slot="bankAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payeeBankCard || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="付款账号" slot="payAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payerBankCard || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="交易信息来源" slot="getWay" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.getWay == '00'">主动查询</div>
          <div v-if="row.getWay == '01'">微众通知</div>
        </template>
      </el-table-column>
      <el-table-column width="300" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row)">上账至回收商</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!--手动查询确认-->
    <el-dialog title='手动查询确认' :visible.sync="commandShow" :close-on-click-modal="false" width="600px"
      @closed="commonclose">
      <div class="enable-tip">
        <div>查询后，需等待查询完毕后才可继续查询，是否确认查询？
        </div>
      </div>
      <div class="command">
        <div style="width: 85px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commonclose">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="renewSubmit" :disabled="disabled">{{ searchTitle
        }}</el-button>
      </span>
    </el-dialog>
    <!--导出弹框-->
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="code = ''">
      <div style="font-size: 14px;margin-bottom: 20px;">
        <div style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？</div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 10px;">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="codeShow = false">取消</el-button>
        <el-button type="primary" :loading="isExport" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!--上账至回收商弹框-->
    <el-dialog title="上账至回收商" :visible.sync="accountEntryShow" :close-on-click-modal="false" width="600px"
      @closed="FromBack" v-if="accountEntryShow">
      <div style="margin-bottom: 10px;">上账金额：¥{{ obj.rechargeAmount }}({{ obj.rechargeAmount | formatChineseCurrency }})
      </div>
      <div style="margin-bottom: 10px;">付款姓名:{{ obj.payerBankCardholder }}</div>
      <div style="margin-bottom: 10px;">付款账号:{{ obj.payerBankCard }}</div>
      <div style="margin-bottom: 10px;">付款银行:{{ obj.payerBankOpening }}</div>
      <div style="margin-bottom: 10px;">交易备注:{{ obj.rechargeNote }}</div>
      <GlobalForm ref="ruleform" :uploadLength="3" :init-data="initData" :form-rules="formRules"
        :form-item-list="formItemList" @handleConfirm="handleConfirm" confirmBtnName="确认提交" style="margin-top: 10px;"
        class="mycommandform">
        <el-form-item class="el_from" label="选择回收商" prop="matchChannelId" slot="matchChannelId">
          <el-select ref="select1" v-model="initData.matchChannelId" placeholder="请输入查询或选择回收商查询" filterable clearable
            @change="handleChange">
            <el-option v-for="item in storeoption" :key="item.merchantId" :label="item.merchantName"
              :value="item.merchantId"></el-option>
          </el-select>
        </el-form-item>
        <div class="name_merchat" slot="voucher">
          <el-form-item
            label="收款凭证"
            prop="voucher"
            style="margin: 0;"
            slot="voucher"
            label-width="80px"
          >
            <JudgementsList
              :is-reset="isResponsibilityReset"
              :source-data="initData.voucher"
              @dataChange="(v) => judgementsChange(v)"
              :assignmentData="assignmentData"
              :state="imgdetailData.state"
            />
            
          </el-form-item>
          <p class="el-upload__tip">请上传本次的收款凭证（限3张内，大小不超过2M，格式为JPG或PNG）</p>
        </div>
        <el-form-item class="el_from" label="谷歌验证码" prop="cause" slot="cause">
          <el-input oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')" placeholder="请输入谷歌验证码"
            v-model="initData.cause" class="mycommand"></el-input>
        </el-form-item>
        <el-button slot="btnSlot" @click="FromBack">取消</el-button>
      </GlobalForm>
    </el-dialog>
  </div>
</template>

<script>
import JudgementsList from "../../componets/JudgementsList.vue";
import { _http } from "@/utils/request/rechargeRecord";
import _api from "@/utils/request";
export default {
  name: "Table",
  props: {
    // accountType: {
    //   require: true,
    //   type: String
    // },
  },
  components:{
    JudgementsList
  },
  data() {
    return {
      imgdetailData: {
        cview: {
          auditStaffInfo: "",
        },
        state: "00",
      },
      assignmentData: [],
      isResponsibilityReset: false,
      isExport: false,
      command: "",
      params: {},
      commandShow: false,
      loading: false,
      butLoading: false,
      seachDataList: [],
      transferStatus: '',
      page: {
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      tableColumns: [
        { slotName: "bizType" },
        { label: "交易时间", prop: "rechargeTime" },
        { slotName: "relationNo" },
        { slotName: "bankAccount" },
        { label: "交易金额", prop: "rechargeAmount" },
        { label: "付款姓名", prop: "payerBankCardholder" },
        { slotName: "payAccount" },
        { label: "付款银行", prop: "payerBankOpening" },
        { label: "交易备注", prop: "rechargeNote" },
        { slotName: "getWay" },
        { label: "信息获取时间", prop: "createTime" },
        { slotName: "operation" }
      ],
      bizType: "",
      codeShow: false,
      code: "",
      obj: {},//上账对象,

      accountEntryShow: false,
      initData: {
        matchChannelId: "",
        voucher: [],
        cause: "",
      },
      formRules: {
        matchChannelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择回收商"
          },
        ],
        voucher: [
          {
            required: true,
            trigger: "change",
            message: "请上传图片",
          },
        ],
        cause: [
          {
            required: true,
            trigger: "blur",
            message: "请输入谷歌验证码",
          },
        ],
      },
      formItemList: [
        { slotName: 'matchChannelId' },
        { slotName: 'balance' },
        { slotName: 'voucher' },
        { slotName: "cause" },
      ],
      params1: {},
      storeoption: [],//回收商
      noticeTime: "",
      selectTime: "",
      disabled: false,
      searchTitle: "确认查询"
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
  },
  filters: {
    formatChineseCurrency(num) {
      console.log(num,"num")
      if (num === 0) return "零元";

      const units = ["", "拾", "佰", "仟", "万", "拾", "佰", "仟", "亿", "拾", "佰", "仟", "万", "拾", "佰", "仟"];

      const nums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];

      let result = "";

      let zero = true;

      // 处理整数部分

      let integerPart = Math.floor(num);

      for (let i = 0; i < units.length; i++) {

        let n = Math.floor(integerPart / Math.pow(10, units.length - i - 1)) % 10;

        if (n === 0) {

          if (!zero) {

            zero = true;

            result += nums[0];

          }

        } else {

          zero = false;

          result += nums[n] + units[units.length - i - 1];

        }

      }
      console.log(integerPart,"integerPart")
      console.log(result,"result")
      if(!result){
        result="零"
      }
      result = result.replace(/零+/g, "零").replace(/零+$/, "");

      result = result.replace(/零万/g, "万").replace(/零亿/g, "亿");

      if (result.startsWith("壹拾")) {

        result = result.substring(1);

      }

      // 处理小数部分

      let decimalPart = num - integerPart;
      console.log(decimalPart,"decimalPart")
      if (decimalPart > 0) {
        if(integerPart==0){
          result += "零元";
        }
        if(integerPart==1){
          result += "元";
        }
       

        let decimalStr = decimalPart.toFixed(2).split('.')[1];

        let hasJiao = false;

        for (let i = 0; i < decimalStr.length; i++) {

          let n = parseInt(decimalStr[i]);

          if (i === 0) { // 角

            if (n !== 0) {

              result += nums[n] + "角";

              hasJiao = true;

            } else {

              result += "零角";

            }

          } else if (i === 1) { // 分

            if (n !== 0) {

              result += nums[n] + "分";

            } else if (!hasJiao) {

              result += "零分";

            }

          }

        }

      } else {

        result += "元";

      }
      return result
    },

  },
  mounted() {
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.page.pageNum = 1
      this.handleCurrentChange()
    },
  },
  methods: {
    // 凭证
    judgementsChange(v) {
      console.log(v, "凭证");
      this.initData.voucher = v;
    },
    //关闭动态口令
    commonclose() {
      this.commandShow = false;
      this.command = ''
    },
    //手动查询
    putBlacklist() {
      this.commandShow = true
    },
    //手动查询确认
    renewSubmit() {
      //未识别
      if (!this.command) {
        return this.$message.error("请输入动态口令");
      }
      this.disabled = true
      this.searchTitle = "查询中"
      this.params.command = this.command
      this.butLoading = true
      _http.getQueryWeBack(this.params).then(res => {
        if (res.code == 1) {
          this.commandShow = false
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.disabled = false
          this.searchTitle = "确认查询"
          this.butLoading = false
          this.handleCurrentChange(1)
        }
      }).catch(err => {
        this.commandShow = false
        this.disabled = false
        this.butLoading = false
        this.searchTitle = "确认查询"
        this.handleCurrentChange(1)
      })
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(this.SeachParams, "SeachParams999999999")
      this.$emit('params', this.SeachParams)
      if (!this.SeachParams.startTime) {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
        return this.$message.error("请选择交易时间")
      }
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      }
      const baseRequest = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "00",//待上账 01上账
        identifyState: "00",//未识别00 01已识别
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: "merchant",//回收商
      };
      this.loading = true
      _http.getList(baseRequest).then(res => {
        if (res.code === 1) {
          this.seachDataList = res.data.list.records;
          this.page.total = res.data.list.total;
          this.page.pageNum = res.data.list.current;
          this.noticeTime = res.data.noticeTime
          this.selectTime = res.data.selectTime
          this.loading = false
          this.$emit('data-loaded', res.data)
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 弹出弹框
    handleBtn(row) {
      this.getAllMachineType()
      this.obj = row
      this.accountEntryShow = true
    },
    // 导出
    clickExcel() {
      this.codeShow = true
    },
    // 导出账单弹框确定
    codeSubmit() {
      //未识别
      if (!this.code.trim()) {
        return this.$message.error("请输入动态口令");
      }
      const params = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "00",//待上账 01上账
        identifyState: "00",//未识别00 01已识别
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: "merchant",//回收商
      }
      this.isExport = true
      _http.excel(params).then(res => {
        console.log(res)
        // if (this.SeachParams.startTime) {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => { //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || '导出失败')
            }
          } catch (err) {
            const fileName = "待上账未识别商户充值记录.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.codeShow = false
          }
        })
        reader.readAsText(blob, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        this.isExport = false
      }).catch(err => {
        this.isExport = false
        console.log(err)
      });
    },
    //上传至回收商
    handleConfirm(data) {
      console.log(data);
      if(data.voucher.some(item=>!item.url)){
        return this.$message.error('请上传凭证');
      }
      let params = {
        accountRechargeRecordId: this.obj.id,
        voucher: data.voucher.map(item=>item.url),
        command: data.cause,
        merchantId: data.matchChannelId
      };
      _http.upMerchant(params).then(res => {
        if (res.code == 1) {
          this.accountEntryShow = false
          this.initData.matchChannelId=""
          this.initData.cause=""
          this.initData.voucher=[]
          this.handleCurrentChange(1)
        }
      })
    },
    //取消上传至回收商
    FromBack() {
      this.initData.matchChannelId=""
      this.initData.cause=""
      this.initData.voucher=[]
      this.accountEntryShow = false
    },
    //选择回收商change事件
    handleChange(val) {
      // this.initData.matchChannelId = val
      // if (val) {
      //   this.getMatchChannelAccount(val)
      // } else {
      //   this.compnyList = {
      //     balance: 0,
      //     contactName: "",
      //     contactPhone: "",
      //   }
      // }
    },
    //回收商名称下拉
    getAllMachineType() {
      _api
        .listSimpleMerchantView({
          isFilterMatrix: "01",
          isNice: "",
          pageNum: 1,
          pageSize: 999999,
        })
        .then((res) => {
          console.log(res, "9999999")
          this.storeoption = res.data;
        });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.name_merchat {
  margin-left: -85px;
  /deep/.el-form-item__content {
    width: 425px;
    display: flex;
    align-items: center;
  }
}
.el-upload__tip {
  margin: 10px 0 5px 90px;
}
.GlobalTable {
  .qb_act {
    display: flex;
    margin: 10px 0;

    .qukliy_box {
      font-size: 13px;
      margin-right: 10px;
      line-height: 13px;
      border-radius: 5px;
      padding: 5px 10px;
      background-color: #e4ecfd;
      color: rgb(9, 129, 255);
    }
  }

  .generated {
    margin-left: -30px;
  }

  .ga_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  // 备注说明
  .enable-tip {
    color: #FF8080;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .el_from {
    margin-left: -120px;
    margin-bottom: 0;
  }

  /deep/.el-select {
    width: 100% !important;
  }

  .command {
    display: flex;
    align-items: center;

    /deep/.el-input {
      width: 300px;
    }
  }

  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .openSytle {
    padding: 20px 10px;
    background-color: #F5F5F5;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }

  .button_top {
    margin-bottom: 20px;
    ;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .faultBtn {
    width: 280px;
    height: 34px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;

    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981FF;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }

  .verify-title {
    color: #0981FF;
    line-height: 16px;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }

  .repair_dialog {
    /deep/.el-dialog__body {
      padding: 0 20px 0 20px;
    }

    /deep/.el-loading-mask .el-loading-spinner {
      margin-top: -35px !important;
    }
  }

  .repair-conent {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .verify-mark {
    width: max-content;
    font-size: 12px;
    color: #fff;
    padding: 0 6px;
    background: #FF687B;
    border-radius: 10px 8px 8px 0px;
    margin-left: 10px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .flex-ac {
    align-items: center;
    justify-content: flex-start;
  }
}

/deep/ .el-form-item:nth-child(5) {
  display: flex;
  justify-content: flex-end;
}

/deep/.mycommandform .el-input {
  width: 300px;
}
</style>
